'use client';

import React from 'react';
import { Drawer, Text, IconButton, Flex, VStack, Heading } from '@skin-seoul/design-system';
import LucideIcon from '@/components/ui/LucideIcon';
import { SORT_OPTIONS } from '../constants/sortOptions';
import type { ProductSortBy } from '@skin-seoul/service';
interface MobileSortDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onSortByChange?: (sortBy: string) => void;
  sortBy?: ProductSortBy;
}
const MobileSortDrawer = ({
  isOpen,
  onClose,
  onSortByChange,
  sortBy
}: MobileSortDrawerProps) => {
  const handleSortChange = (value: string) => {
    if (onSortByChange) {
      onSortByChange(value);
    }
    onClose();
  };
  return <Drawer.Root placement="bottom" initialFocusEl={() => null} open={isOpen} onOpenChange={details => {
    if (!details.open) {
      onClose();
    }
  }} data-sentry-element="Drawer.Root" data-sentry-component="MobileSortDrawer" data-sentry-source-file="MobileSortDrawer.tsx">
      <Drawer.Backdrop data-sentry-element="Drawer.Backdrop" data-sentry-source-file="MobileSortDrawer.tsx" />
      <Drawer.Positioner data-sentry-element="Drawer.Positioner" data-sentry-source-file="MobileSortDrawer.tsx">
        <Drawer.Content alignItems="stretch" backgroundColor="white" width="100%" height="95%" borderRadius="12px 12px 0 0" paddingY={5} paddingX={4} gap={6} data-sentry-element="Drawer.Content" data-sentry-source-file="MobileSortDrawer.tsx">
          <Drawer.Header alignItems="center" display="flex" flexDirection="row" width="100%" justifyContent="space-between" padding={0} data-sentry-element="Drawer.Header" data-sentry-source-file="MobileSortDrawer.tsx">
            <Flex align="center" gap={2} data-sentry-element="Flex" data-sentry-source-file="MobileSortDrawer.tsx">
              <LucideIcon name="ArrowDownUp" boxSize={5} data-sentry-element="LucideIcon" data-sentry-source-file="MobileSortDrawer.tsx" />
              <Heading as="h6" fontWeight="medium" textStyle="heading.h6" color="neutral.800" data-sentry-element="Heading" data-sentry-source-file="MobileSortDrawer.tsx">
                Sort
              </Heading>
            </Flex>
            <IconButton _hover={{
            backgroundColor: 'transparent'
          }} aria-label="Close sort options" backgroundColor="transparent" border="none" cursor="pointer" width={6} height={6} onClick={onClose} data-sentry-element="IconButton" data-sentry-source-file="MobileSortDrawer.tsx">
              <LucideIcon name="X" color="neutral.800" boxSize={5} data-sentry-element="LucideIcon" data-sentry-source-file="MobileSortDrawer.tsx" />
            </IconButton>
          </Drawer.Header>

          <Drawer.Body flex="1 1 auto" overflow="auto" width="100%" padding={0} data-sentry-element="Drawer.Body" data-sentry-source-file="MobileSortDrawer.tsx">
            <VStack gap={0} align="stretch" data-sentry-element="VStack" data-sentry-source-file="MobileSortDrawer.tsx">
              {SORT_OPTIONS.map(option => <Flex key={option.value} align="center" justify="space-between" paddingY={4} borderBottom="1px solid" borderBottomColor="neutral.100" cursor="pointer" _last={{
              borderBottom: 'none'
            }} onClick={() => handleSortChange(option.value)}>
                  <Text textStyle="paragraph.small" color="neutral.600" fontWeight={sortBy === option.value ? 'semibold' : 'regular'}>
                    {option.label}
                  </Text>
                  <Flex width={4} height={4} borderRadius="2px" border="1px solid" borderColor={sortBy === option.value ? 'neutral.700' : 'neutral.300'} backgroundColor={sortBy === option.value ? 'neutral.700' : 'transparent'} alignItems="center" justifyContent="center">
                    {sortBy === option.value && <LucideIcon name="Check" color="generic.0" boxSize={3} />}
                  </Flex>
                </Flex>)}
            </VStack>
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>;
};
export default MobileSortDrawer;